import { cn } from '@/lib/utils';

/** 12-column tile board: mixed widths/heights, dense-packed via CSS grid */
export const DASHBOARD_TILE_LAYOUT = {
  notification_tracker: {
    order: 10,
    col: { base: 12, lg: 12 },
    row: { base: 1 },
  },
  incidents: {
    order: 20,
    col: { base: 12, sm: 6, lg: 4 },
    row: { base: 1 },
  },
  compliance_documents: {
    order: 30,
    col: { base: 12, sm: 6, lg: 4 },
    row: { base: 1 },
  },
  policy: {
    order: 40,
    col: { base: 12, sm: 6, lg: 4 },
    row: { base: 1 },
  },
  invoice_followups: {
    order: 50,
    col: { base: 12, sm: 6, lg: 4 },
    row: { base: 1 },
  },
  quotes: {
    order: 60,
    col: { base: 12, sm: 6, lg: 4 },
    row: { base: 1 },
  },
  service_agreements: {
    order: 70,
    col: { base: 12, sm: 6, lg: 4 },
    row: { base: 1 },
  },
  esignatures: {
    order: 80,
    col: { base: 12, sm: 6, lg: 4 },
    row: { base: 1 },
  },
  jobs: {
    order: 90,
    col: { base: 12, sm: 6, lg: 4 },
    row: { base: 1 },
  },
  reference_checks: {
    order: 100,
    col: { base: 12, sm: 6, lg: 4 },
    row: { base: 1 },
  },
  leave: {
    order: 110,
    col: { base: 12, lg: 6 },
    row: { base: 1 },
  },
};

const COL_CLASS = {
  12: 'col-span-12',
  6: 'col-span-6',
  4: 'col-span-4',
};

const SM_COL_CLASS = {
  6: 'sm:col-span-6',
  4: 'sm:col-span-4',
};

const LG_COL_CLASS = {
  12: 'lg:col-span-12',
  6: 'lg:col-span-6',
  4: 'lg:col-span-4',
};

const ROW_CLASS = {
  1: 'row-span-1',
  2: 'row-span-2',
};

const LG_ROW_CLASS = {
  2: 'lg:row-span-2',
};

export function getDashboardTileClassName(tileId) {
  const layout = DASHBOARD_TILE_LAYOUT[tileId];
  if (!layout) return 'col-span-12 row-span-1';

  const { col, row } = layout;
  return cn(
    COL_CLASS[col.base] || 'col-span-12',
    col.sm && SM_COL_CLASS[col.sm],
    col.lg && LG_COL_CLASS[col.lg],
    ROW_CLASS[row.base] || 'row-span-1',
    row.lg && LG_ROW_CLASS[row.lg],
    'min-h-0 h-full'
  );
}

export function getDashboardTileOrder(tileId) {
  return DASHBOARD_TILE_LAYOUT[tileId]?.order ?? 999;
}
